var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"modal"}},[_c('div',{staticClass:"modal-lair",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"modal-container"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }